require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./cas-cos-2-4-1.json") })
        }
      }, "path---cas-cos-2-4-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---cas-cos-2-4-1!./.cache/json/cas-cos-2-4-1.json
// module id = 360
// module chunks = 231608221292675